import { render, staticRenderFns } from "./inbound-mail-message.vue?vue&type=template&id=eddd9ff0&scoped=true"
import script from "./inbound-mail-message.vue?vue&type=script&lang=js"
export * from "./inbound-mail-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddd9ff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eddd9ff0')) {
      api.createRecord('eddd9ff0', component.options)
    } else {
      api.reload('eddd9ff0', component.options)
    }
    module.hot.accept("./inbound-mail-message.vue?vue&type=template&id=eddd9ff0&scoped=true", function () {
      api.rerender('eddd9ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/messages/inbound-mail-message.vue"
export default component.exports